import React from 'react';

import * as faq from "../store/faq";

class FAQSearchEngine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { setValue, handleKeyDown, handleSearch } = this.props;
        const { searchKeyword } = this.props;

        return(
            <React.Fragment>
                <div className='search-box p-lg-2 p-2 pt-0'>
                    <div className='row align-items-center'>
                        <div className='col-12 d-flex align-items-center'>
                            <input
                                type="text"
                                className="form-control flex-grow-0 me-3 w-75"
                                placeholder="검색 입력"
                                value={searchKeyword}
                                onKeyDown={handleKeyDown}
                                onChange={(e)=>setValue('searchKeyword', e.target.value)}
                            />
                            <div className="d-flex flex-shrink-0">
                                <button className="btn btn-primary btn-sm px-4" onClick={handleSearch}>
                                    검색
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default FAQSearchEngine;
